import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/app/app';
ReactDOM.createRoot(document.getElementById("root")).render(
    <App />
);